import { Directive, Input, OnInit } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";

@Directive({
  selector: "[formGroup][transform],[formGroupName][transform]"
})
export class TransformFormGroupDirective implements OnInit {
  @Input() public readonly transform: (data: any) => any;

  public originalGetValue?: () => any;

  constructor(
    private readonly ngControl: FormGroupDirective,
  ) {
  }

  public ngOnInit() {
    this.originalGetValue = this.ngControl.control.getRawValue

    this.ngControl.control.getRawValue = this.transformValue
  }

  transformValue = () => {
    const rawValue = this.originalGetValue.call(this.ngControl.control);
    return this.transform(rawValue);
  }
}